var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisteredUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    fill: "#2BBFDC",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2834 51C80.1101 51.1459 80.9368 51.2918 81.7635 51.4863C88.7662 53.2856 93.6292 59.7048 93.4347 66.8534C93.2402 74.1965 88.1341 80.3725 80.9854 81.8314C72.0862 83.6307 63.4786 77.4061 62.4088 68.4582C61.3876 59.8993 67.4663 52.1671 76.1224 51.0973C76.2683 51.0973 76.4142 51 76.5601 51C77.4355 51 78.3594 51 79.2834 51Z",
    fill: "url(#paint0_linear_360_27461)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4177 113.295C83.0773 113.295 82.8341 113.295 82.591 113.295C75.9286 113.295 69.315 113.295 62.6526 113.295C56.5739 113.295 52.3917 108.383 53.0725 102.353C53.8506 95.7393 58.7136 90.1955 65.23 88.7852C66.3485 88.5421 67.467 88.4448 68.5855 88.4448C74.8102 88.3962 81.0348 88.3476 87.3081 88.4448C93.8731 88.5421 98.5902 91.703 101.459 97.5873C101.654 98.0249 101.605 98.2681 101.265 98.6085C100.195 99.5811 99.2224 100.602 98.1526 101.672C96.0128 99.1921 93.3868 97.6359 89.9827 97.7818C87.6971 97.879 85.6546 98.7544 84.0012 100.311C80.5971 103.423 79.819 109.015 83.4177 113.295Z",
    fill: "url(#paint1_linear_360_27461)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1043 110.473C99.4659 109.112 100.779 107.847 102.043 106.583C104.669 103.957 107.295 101.331 109.921 98.705C110.797 97.8296 111.867 97.4892 113.082 97.8783C114.201 98.2187 114.93 98.9968 115.173 100.164C115.465 101.38 115.027 102.401 114.152 103.228C111.867 105.513 109.581 107.847 107.247 110.133C105.01 112.37 102.821 114.558 100.584 116.795C98.9796 118.4 97.2289 118.4 95.6241 116.795C93.144 114.315 90.6152 111.835 88.1351 109.306C86.3844 107.556 87.1625 104.686 89.5454 104.054C90.7125 103.762 91.7337 104.103 92.6091 104.93C94.2625 106.583 95.9159 108.236 97.5693 109.89C97.7638 110.036 97.9097 110.23 98.1043 110.473Z",
    fill: "url(#paint2_linear_360_27461)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_27461",
    x1: 62.2978,
    y1: 66.5687,
    x2: 93.4438,
    y2: 66.5687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_27461",
    x1: 53.0014,
    y1: 100.84,
    x2: 101.579,
    y2: 100.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_360_27461",
    x1: 87.1844,
    y1: 107.857,
    x2: 115.267,
    y2: 107.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredUser);
export default __webpack_public_path__ + "static/media/registered-user.9967b77c801e41ac9b05d300009b0162.svg";
export { ForwardRef as ReactComponent };